import React from 'react';
import { Button as AntButton, ButtonProps as AntButtonProps } from 'antd';
import { styled } from 'styled-components';

interface CustomButtonProps extends Omit<AntButtonProps, 'variant'> {
  buttonVariant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  fullWidth?: boolean;
}

const StyledButton = styled(AntButton)<CustomButtonProps>`
  ${props => props.fullWidth && 'width: 100%;'}
  
  &.ant-btn-secondary {
    background-color: #f5f5f5;
    border-color: #d9d9d9;
    color: #666;
    
    &:hover {
      background-color: #e6f7ff;
      border-color: #1890ff;
      color: #1890ff;
    }
  }
`;

export const Button: React.FC<CustomButtonProps> = ({
  buttonVariant = 'primary',
  fullWidth = false,
  children,
  className,
  ...props
}) => {
  const buttonType = buttonVariant === 'primary' ? 'primary' : 
                    buttonVariant === 'danger' ? 'primary' : 
                    buttonVariant === 'ghost' ? 'default' : 'default';
  
  const buttonClass = `${className || ''} ${buttonVariant === 'secondary' ? 'ant-btn-secondary' : ''}`.trim();

  return (
    <StyledButton
      type={buttonType}
      danger={buttonVariant === 'danger'}
      ghost={buttonVariant === 'ghost'}
      fullWidth={fullWidth}
      className={buttonClass}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

export default Button; 